module.exports = __webpack_public_path__ + "static/media/motorcycle.8a2e25cf.svg";